<template>
  <SegmentGroupAnswers
    :options="options"
    skipConfirmRemove
    noMargin
    noFilter
    buttonLabel="Add option"
    :key-field="'index'">
    <template #input="{ option, index }">
      <div class="flex items-center gap-3 w-full">
        <InputText
          :modelValue="option.name"
          @update:modelValue="
            (value) => $emit('update:option', { ...option, name: value }, index)
          "
          class="w-full" />
        &rarr;
        <InputText
          :modelValue="option.id"
          @update:modelValue="
            (value) => $emit('update:option', { ...option, id: value }, index)
          "
          class="w-24" />
      </div>
    </template>
  </SegmentGroupAnswers>
</template>

<script setup lang="ts">
defineProps<{
  options: Array<{ name: string; id: string }>
}>()

defineEmits<{
  'update:option': [option: { name: string; id: string }, index: number]
}>()
</script>
